import { Fragment } from 'react';

import { Table } from '~/components/Elements';

import { Headline, HeadlineSub, Intro } from '../styles';

const FormStable = props => {
  const {
    type,
    data: { [type]: data },
  } = props;

  return (
    <Fragment>
      <Headline>{data.headline}</Headline>
      <Intro>{data.intro}</Intro>
      {['best', 'worst'].map(type => (
        <Fragment key={type}>
          <HeadlineSub>{data[type].intro}</HeadlineSub>

          <Table>
            <thead>
              <tr>
                <th>Namn</th>
                <th>Starter</th>
                <th>Segrar</th>
                <th>Segerprocent</th>
                <th>ROI ATG</th>
              </tr>
            </thead>
            <tbody>
              {data[type].results.map(stat => (
                <tr key={stat.val}>
                  <td>{stat.name}</td>
                  <td>{stat.number_of_starts}</td>
                  <td>{stat.number_of_wins}</td>
                  <td>{stat.win_percent}%</td>
                  <td>{stat.roi}%</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Fragment>
      ))}
    </Fragment>
  );
};

export default FormStable;
